import React from 'react'

import ProjectSession from "../../../../model2/project/project-session"
import UserIcon from "../../../../gd-ui/icon/user/user"

type Props = {
    projectId   : ID
    userId      : ID
}

// const debug = "ProjectUserIcon"
const debug = false

export default function ProjectUserIcon(props: Props) {
    const sessionProject: ProjectSession = gd.session.projects.get(props.projectId)!

    debug && console.log(debug, 'render', sessionProject)

    return (
        <div className="details-project-user-icon">
            <div className={Classes("project-big s1 gd-c-{0}".f(sessionProject.color), sessionProject.iconClass)}/>
            <UserIcon className="" size="54" userId={props.userId}/>
        </div>
    )
}